import React, { Component } from "react";
import InsureCompImage from "../assets/images/new-logo.png";

class Navbar extends Component {
  render() {
    return (
      <nav className="navbar navbar-light bg-white border-bottom shadow-sm mb-5 py-3">
        <div className="container d-flex align-items-center justify-content-between">
          <div className="navbar-brand d-flex align-items-center">
            <img 
              className="logoMain img-fluid" 
              src={InsureCompImage} 
              alt="Insure Logo" 
              style={{ maxHeight: "45px", objectFit: "contain" }}
            />
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;